export const busRoutes = [
  {
    route: 'Green Route',
    id: '7002',
  },
  {
    route: 'Orange Route',
    id: '7003',
  },
  {
    route: 'Red Route',
    id: '7001',
  },
];

const greenRoute = {
  ladder: {
    isVisible: 'true',
    routeId: ['7002'],
    routeName: ['7002'],
    direction: [
      {
        value: '2',
        stops: [
          {
            streetName: 'Green Route',
            stopCode: 'GS10',
            stopName: 'Liverpool Landing',
            latitude: 1.340476,
            longitude: 103.637113,
            stopSequence: '1',
            mrtStationCode: '',
            mrtStationName: '',
            ctrCode: null,
          },
          {
            streetName: 'Green Route',
            stopCode: 'GS9',
            stopName: 'Bristol Bridge',
            latitude: 1.336771,
            longitude: 103.705133,
            stopSequence: '2',
            mrtStationCode: '',
            mrtStationName: '',
            ctrCode: null,
          },
          {
            streetName: 'Green Route',
            stopCode: 'GS8',
            stopName: 'Cantebury Court',
            latitude: 1.315043,
            longitude: 103.764998,
            stopSequence: '3',
            mrtStationCode: '',
            mrtStationName: '',
            ctrCode: null,
          },
          {
            streetName: 'Green Route',
            stopCode: 'GS7',
            stopName: 'Leeds Lane',
            latitude: 1.2927635057238263,
            longitude: 103.78620150994891,
            stopSequence: '4',
            mrtStationCode: '',
            mrtStationName: '',
            ctrCode: null,
          },
          {
            streetName: 'Green Route',
            stopCode: 'GS6',
            stopName: 'York Yard',
            latitude: 1.2811824,
            longitude: 103.8409212,
            stopSequence: '5',
            mrtStationCode: '',
            mrtStationName: '',
            ctrCode: null,
          },
          {
            streetName: 'Green Route',
            stopCode: 'GS5',
            stopName: 'Cambridge Cresent',
            latitude: 1.2996007,
            longitude: 103.8550052,
            stopSequence: '6',
            mrtStationCode: '',
            mrtStationName: '',
            ctrCode: null,
          },
          {
            streetName: 'Green Route',
            stopCode: 'GS4',
            stopName: 'Oxford Overpass',
            latitude: 1.3179272,
            longitude: 103.891838,
            stopSequence: '7',
            mrtStationCode: '',
            mrtStationName: '',
            ctrCode: null,
          },
          {
            streetName: 'Green Route',
            stopCode: 'GS3',
            stopName: 'Windsor Way',
            latitude: 1.3237203,
            longitude: 103.9290162,
            stopSequence: '8',
            mrtStationCode: '',
            mrtStationName: '',
            ctrCode: null,
          },
          {
            streetName: 'Green Route',
            stopCode: 'GS2',
            stopName: 'Stratford',
            latitude: 1.3518124,
            longitude: 103.9437422,
            stopSequence: '9',
            mrtStationCode: '',
            mrtStationName: '',
            ctrCode: null,
          },
          {
            streetName: 'Green Route',
            stopCode: 'GS1',
            stopName: 'Buckingham Blvd',
            latitude: 1.3725841,
            longitude: 103.9480903,
            stopSequence: '10',
            mrtStationCode: '',
            mrtStationName: '',
            ctrCode: null,
          },
        ],
      },
      {
        value: '1',
        stops: [
          {
            streetName: 'Green Route',
            stopCode: 'GS1',
            stopName: 'Buckingham Blvd',
            latitude: 1.3725841,
            longitude: 103.9480903,
            stopSequence: '1',
            mrtStationCode: '',
            mrtStationName: '',
            ctrCode: null,
          },
          {
            streetName: 'Green Route',
            stopCode: 'GS2',
            stopName: 'Stratford',
            latitude: 1.3518124,
            longitude: 103.9437422,
            stopSequence: '2',
            mrtStationCode: '',
            mrtStationName: '',
            ctrCode: null,
          },
          {
            streetName: 'Green Route',
            stopCode: 'GS3',
            stopName: 'Windsor Way',
            latitude: 1.3237203,
            longitude: 103.9290162,
            stopSequence: '3',
            mrtStationCode: '',
            mrtStationName: '',
            ctrCode: null,
          },
          {
            streetName: 'Green Route',
            stopCode: 'GS4',
            stopName: 'Oxford Overpass',
            latitude: 1.3179272,
            longitude: 103.891838,
            stopSequence: '4',
            mrtStationCode: '',
            mrtStationName: '',
            ctrCode: null,
          },
          {
            streetName: 'Green Route',
            stopCode: 'GS5',
            stopName: 'Cambridge Cresent',
            latitude: 1.2996007,
            longitude: 103.8550052,
            stopSequence: '5',
            mrtStationCode: '',
            mrtStationName: '',
            ctrCode: null,
          },
          {
            streetName: 'Green Route',
            stopCode: 'GS6',
            stopName: 'York Yard',
            latitude: 1.2811824,
            longitude: 103.8409212,
            stopSequence: '6',
            mrtStationCode: '',
            mrtStationName: '',
            ctrCode: null,
          },
          {
            streetName: 'Green Route',
            stopCode: 'GS7',
            stopName: 'Leeds Lane',
            latitude: 1.2927635057238263,
            longitude: 103.78620150994891,
            stopSequence: '7',
            mrtStationCode: '',
            mrtStationName: '',
            ctrCode: null,
          },
          {
            streetName: 'Green Route',
            stopCode: 'GS8',
            stopName: 'Cantebury Court',
            latitude: 1.315043,
            longitude: 103.764998,
            stopSequence: '8',
            mrtStationCode: '',
            mrtStationName: '',
            ctrCode: null,
          },
          {
            streetName: 'Green Route',
            stopCode: 'GS9',
            stopName: 'Bristol Bridge',
            latitude: 1.336771,
            longitude: 103.705133,
            stopSequence: '9',
            mrtStationCode: '',
            mrtStationName: '',
            ctrCode: null,
          },
          {
            streetName: 'Green Route',
            stopCode: 'GS10',
            stopName: 'Liverpool Landing',
            latitude: 1.340476,
            longitude: 103.637113,
            stopSequence: '10',
            mrtStationCode: '',
            mrtStationName: '',
            ctrCode: null,
          },
        ],
      },
    ],
  },
  stops: [
    {
      direction: 1,
      stop: [
        {
          stopSequence: '1',
          stopCode: 'GS1',
          index: 0,
        },
        {
          stopSequence: '2',
          stopCode: 'GS2',
          index: 131,
        },
        {
          stopSequence: '3',
          stopCode: 'GS3',
          index: 360,
        },
        {
          stopSequence: '4',
          stopCode: 'GS4',
          index: 509,
        },
        {
          stopSequence: '5',
          stopCode: 'GS5',
          index: 881,
        },
        {
          stopSequence: '6',
          stopCode: 'GS6',
          index: 995,
        },
        {
          stopSequence: '7',
          stopCode: 'GS7',
          index: 1238,
        },
        {
          stopSequence: '8',
          stopCode: 'GS8',
          index: 1430,
        },
        {
          stopSequence: '9',
          stopCode: 'GS9',
          index: 1794,
        },
        {
          stopSequence: '10',
          stopCode: 'GS10',
          index: 2187,
        },
      ],
    },
    {
      direction: 2,
      stop: [
        {
          stopSequence: '1',
          stopCode: 'GS10',
          index: 0,
        },
        {
          stopSequence: '2',
          stopCode: 'GS9',
          index: 392,
        },
        {
          stopSequence: '3',
          stopCode: 'GS8',
          index: 757,
        },
        {
          stopSequence: '4',
          stopCode: 'GS7',
          index: 948,
        },
        {
          stopSequence: '5',
          stopCode: 'GS6',
          index: 1192,
        },
        {
          stopSequence: '6',
          stopCode: 'GS5',
          index: 1306,
        },
        {
          stopSequence: '7',
          stopCode: 'GS4',
          index: 1677,
        },
        {
          stopSequence: '8',
          stopCode: 'GS3',
          index: 1826,
        },
        {
          stopSequence: '9',
          stopCode: 'GS2',
          index: 2054,
        },
        {
          stopSequence: '10',
          stopCode: 'GS1',
          index: 2187,
        },
      ],
    },
  ],
  color: '#038803',
  colorAlt: '#086608',
  colorAlt2: '#064A06',
  busCode: 'G',
  busCount: 6,
  busId: 7002,
  timeStop: 5,
  busIdStr: '7002',
  busArr: ['SG6042C', 'SG1713H', 'SG5031R', 'SG1894T', 'SG5115H', 'SG6184B'],
};

const redRoute = {
  ladder: {
    isVisible: 'true',
    routeId: ['7001'],
    routeName: ['7001'],
    direction: [
      {
        value: '2',
        stops: [
          {
            streetName: 'Red Route',
            stopCode: 'RS7',
            stopName: 'Lancaster Loop',
            latitude: 1.425144,
            longitude: 103.76106,
            stopSequence: '1',
            mrtStationCode: '',
            mrtStationName: '',
            ctrCode: null,
          },
          {
            streetName: 'Red Route',
            stopCode: 'RS6',
            stopName: 'Victoria Vault',
            latitude: 1.363013,
            longitude: 103.767414,
            stopSequence: '2',
            mrtStationCode: '',
            mrtStationName: '',
            ctrCode: null,
          },
          {
            streetName: 'Red Route',
            stopCode: 'RS5',
            stopName: 'Preston Plaza',
            latitude: 1.3409,
            longitude: 103.775838,
            stopSequence: '3',
            mrtStationCode: '',
            mrtStationName: '',
            ctrCode: null,
          },
          {
            streetName: 'Red Route',
            stopCode: 'RS4',
            stopName: 'Hastings Harbor',
            latitude: 1.3225964,
            longitude: 103.8150076,
            stopSequence: '4',
            mrtStationCode: '',
            mrtStationName: '',
            ctrCode: null,
          },
          {
            streetName: 'Red Route',
            stopCode: 'RS3',
            stopName: 'Greenwich Grove',
            latitude: 1.3029758,
            longitude: 103.8319635,
            stopSequence: '5',
            mrtStationCode: '',
            mrtStationName: '',
            ctrCode: null,
          },
          {
            streetName: 'Red Route',
            stopCode: 'RS2',
            stopName: 'Chester Chase',
            latitude: 1.293306,
            longitude: 103.852408,
            stopSequence: '6',
            mrtStationCode: '',
            mrtStationName: '',
            ctrCode: null,
          },
          {
            streetName: 'Red Route',
            stopCode: 'RS1',
            stopName: 'Kingston Quay',
            latitude: 1.2774322,
            longitude: 103.8554115,
            stopSequence: '7',
            mrtStationCode: '',
            mrtStationName: '',
            ctrCode: null,
          },
        ],
      },
      {
        value: '1',
        stops: [
          {
            streetName: 'Red Route',
            stopCode: 'RS1',
            stopName: 'Kingston Quay',
            latitude: 1.2774322,
            longitude: 103.8554115,
            stopSequence: '1',
            mrtStationCode: '',
            mrtStationName: '',
            ctrCode: null,
          },
          {
            streetName: 'Red Route',
            stopCode: 'RS2',
            stopName: 'Chester Chase',
            latitude: 1.293306,
            longitude: 103.852408,
            stopSequence: '2',
            mrtStationCode: '',
            mrtStationName: '',
            ctrCode: null,
          },
          {
            streetName: 'Red Route',
            stopCode: 'RS3',
            stopName: 'Greenwich Grove',
            latitude: 1.3029758,
            longitude: 103.8319635,
            stopSequence: '3',
            mrtStationCode: '',
            mrtStationName: '',
            ctrCode: null,
          },
          {
            streetName: 'Red Route',
            stopCode: 'RS4',
            stopName: 'Hastings Harbor',
            latitude: 1.3225964,
            longitude: 103.8150076,
            stopSequence: '4',
            mrtStationCode: '',
            mrtStationName: '',
            ctrCode: null,
          },
          {
            streetName: 'Red Route',
            stopCode: 'RS5',
            stopName: 'Preston Plaza',
            latitude: 1.3409,
            longitude: 103.775838,
            stopSequence: '5',
            mrtStationCode: '',
            mrtStationName: '',
            ctrCode: null,
          },
          {
            streetName: 'Red Route',
            stopCode: 'RS6',
            stopName: 'Victoria Vault',
            latitude: 1.363013,
            longitude: 103.767414,
            stopSequence: '6',
            mrtStationCode: '',
            mrtStationName: '',
            ctrCode: null,
          },
          {
            streetName: 'Red Route',
            stopCode: 'RS7',
            stopName: 'Lancaster Loop',
            latitude: 1.425144,
            longitude: 103.76106,
            stopSequence: '7',
            mrtStationCode: '',
            mrtStationName: '',
            ctrCode: null,
          },
        ],
      },
    ],
  },
  stops: [
    {
      direction: 1,
      stop: [
        {
          stopSequence: '1',
          stopCode: 'RS1',
          index: 0,
        },
        {
          stopSequence: '2',
          stopCode: 'RS2',
          index: 125,
        },
        {
          stopSequence: '3',
          stopCode: 'RS3',
          index: 250,
        },
        {
          stopSequence: '4',
          stopCode: 'RS4',
          index: 434,
        },
        {
          stopSequence: '5',
          stopCode: 'RS5',
          index: 609,
        },
        {
          stopSequence: '6',
          stopCode: 'RS6',
          index: 742,
        },
        {
          stopSequence: '7',
          stopCode: 'RS7',
          index: 1098,
        },
      ],
    },
    {
      direction: 2,
      stop: [
        {
          stopSequence: '1',
          stopCode: 'RS7',
          index: 0,
        },
        {
          stopSequence: '2',
          stopCode: 'RS6',
          index: 356,
        },
        {
          stopSequence: '3',
          stopCode: 'RS5',
          index: 490,
        },
        {
          stopSequence: '4',
          stopCode: 'RS4',
          index: 665,
        },
        {
          stopSequence: '5',
          stopCode: 'RS3',
          index: 848,
        },
        {
          stopSequence: '6',
          stopCode: 'RS2',
          index: 973,
        },
        {
          stopSequence: '7',
          stopCode: 'RS1',
          index: 1098,
        },
      ],
    },
  ],
  color: '#f03030',
  colorAlt: '#991010',
  colorAlt2: '#600808',
  busCode: 'R',
  busCount: 3,
  busId: 7001,
  busIdStr: '7001',
  timeStop: 5,
  busArr: ['SG1791G', 'SG6186X', 'SG5143B'],
};

const orangeRoute = {
  ladder: {
    isVisible: 'true',
    routeId: ['7003'],
    routeName: ['7003'],
    direction: [
      {
        value: '2',
        stops: [
          {
            streetName: 'Orange Route',
            stopCode: 'OS5',
            stopName: 'Manchester Meadows',
            latitude: 1.4048144,
            longitude: 103.902759321,
            stopSequence: '1',
            mrtStationCode: '',
            mrtStationName: '',
            ctrCode: null,
          },
          {
            streetName: 'Orange Route',
            stopCode: 'OS4',
            stopName: 'Docklands Pier',
            latitude: 1.3711822747611109,
            longitude: 103.89246560907316,
            stopSequence: '2',
            mrtStationCode: '',
            mrtStationName: '',
            ctrCode: null,
          },
          {
            streetName: 'Orange Route',
            stopCode: 'OS3',
            stopName: 'Stadium',
            latitude: 1.349162,
            longitude: 103.87301,
            stopSequence: '3',
            mrtStationCode: '',
            mrtStationName: '',
            ctrCode: null,
          },
          {
            streetName: 'Orange Route',
            stopCode: 'OS2',
            stopName: 'Library Lane',
            latitude: 1.284154,
            longitude: 103.843081,
            stopSequence: '4',
            mrtStationCode: '',
            mrtStationName: '',
            ctrCode: null,
          },
          {
            streetName: 'Orange Route',
            stopCode: 'OS1',
            stopName: 'Town Hall',
            latitude: 1.2653656,
            longitude: 103.8216731,
            stopSequence: '5',
            mrtStationCode: '',
            mrtStationName: '',
            ctrCode: null,
          },
        ],
      },
      {
        value: '1',
        stops: [
          {
            streetName: 'Orange Route',
            stopCode: 'OS1',
            stopName: 'Town Hall',
            latitude: 1.2653656,
            longitude: 103.8216731,
            stopSequence: '1',
            mrtStationCode: '',
            mrtStationName: '',
            ctrCode: null,
          },
          {
            streetName: 'Orange Route',
            stopCode: 'OS2',
            stopName: 'Library Lane',
            latitude: 1.284154,
            longitude: 103.843081,
            stopSequence: '2',
            mrtStationCode: '',
            mrtStationName: '',
            ctrCode: null,
          },
          {
            streetName: 'Orange Route',
            stopCode: 'OS3',
            stopName: 'Stadium',
            latitude: 1.349162,
            longitude: 103.87301,
            stopSequence: '3',
            mrtStationCode: '',
            mrtStationName: '',
            ctrCode: null,
          },
          {
            streetName: 'Orange Route',
            stopCode: 'OS4',
            stopName: 'Docklands Pier',
            latitude: 1.3711822747611109,
            longitude: 103.89246560907316,
            stopSequence: '4',
            mrtStationCode: '',
            mrtStationName: '',
            ctrCode: null,
          },
          {
            streetName: 'Orange Route',
            stopCode: 'OS5',
            stopName: 'Manchester Meadows',
            latitude: 1.4048144,
            longitude: 103.902759321,
            stopSequence: '5',
            mrtStationCode: '',
            mrtStationName: '',
            ctrCode: null,
          },
        ],
      },
    ],
  },
  stops: [
    {
      direction: 1,
      stop: [
        {
          stopSequence: '1',
          stopCode: 'OS1',
          index: 0,
        },
        {
          stopSequence: '2',
          stopCode: 'OS2',
          index: 255,
        },
        {
          stopSequence: '3',
          stopCode: 'OS3',
          index: 712,
        },
        {
          stopSequence: '4',
          stopCode: 'OS4',
          index: 884,
        },
        {
          stopSequence: '5',
          stopCode: 'OS5',
          index: 1156,
        },
      ],
    },
    {
      direction: 2,
      stop: [
        {
          stopSequence: '1',
          stopCode: 'OS5',
          index: 0,
        },
        {
          stopSequence: '2',
          stopCode: 'OS4',
          index: 272,
        },
        {
          stopSequence: '3',
          stopCode: 'OS3',
          index: 444,
        },
        {
          stopSequence: '4',
          stopCode: 'OS2',
          index: 900,
        },
        {
          stopSequence: '5',
          stopCode: 'OS1',
          index: 1156,
        },
      ],
    },
  ],
  color: '#FFA500',
  colorAlt: '#F08000',
  colorAlt2: '#FF7518',
  busCode: 'O',
  busCount: 5,
  busId: 7003,
  busIdStr: '7003',
  timeStop: 5,
  busArr: ['SG1769Y', 'SG1778X', 'SG1784C', 'SG1759B', 'SG1768A'],
};

export const routeData = {
  '7001': redRoute,
  '7002': greenRoute,
  '7003': orangeRoute,
};

export const stopNames = {
  GS1: 'Buckingham Blvd',
  GS2: 'Stratford',
  GS3: 'Windsor Way',
  GS4: 'Oxford Overpass',
  GS5: 'Cambridge Cresent',
  GS6: 'York Yard',
  GS7: 'Leeds Lane',
  GS8: 'Cantebury Court',
  GS9: 'Bristol Bridge',
  GS10: 'Liverpool Landing',
  OS1: 'Town Hall',
  OS2: 'Library Lane',
  OS3: 'Stadium',
  OS4: 'Docklands Pier',
  OS5: 'Manchester Meadows',
  RS1: 'Kingston Quay',
  RS2: 'Chester Chase',
  RS3: 'Greenwich Grove',
  RS4: 'Hastings Harbor',
  RS5: 'Preston Plaza',
  RS6: 'Victoria Vault',
  RS7: 'Lancaster Loop',
};
